import { inject, Injectable } from '@angular/core';
import { Papa } from 'ngx-papaparse';
import { FileParser, FileParseResult } from './file-parser.interface';

@Injectable({
  providedIn: 'root',
})
export class CsvFileParserService implements FileParser {
  private readonly papa = inject(Papa);

  canParse(file: File): boolean {
    const extension = this.getFileExtension(file.name);
    return extension === 'csv';
  }

  async parse(file: File, preview?: number): Promise<FileParseResult> {
    return new Promise((resolve, reject) => {
      this.papa.parse(file, {
        header: false,
        preview: preview,
        skipEmptyLines: true,
        complete: (result) => {
          resolve({
            data: result.data as string[][],
            errors: result.errors || [],
          });
        },
        error: (_error) => {
          reject(new Error('Failed to parse CSV file'));
        },
      });
    });
  }

  private getFileExtension(filename: string): string {
    return filename.split('.').pop()?.toLowerCase() || '';
  }
}
